import * as React from 'react';
import { RssItem } from 'models';

interface Props {
  article: RssItem;
}

function ListItem(props: Props) {
  const date = new Date(props.article.pubDate.replace(' ', 'T'));
  return (
    <article key={props.article.title} className="article-list-item">
      <h3><a href={props.article.link} target="_blank">{props.article.title}</a></h3>
      <span className="date">{`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`}</span>
      <p dangerouslySetInnerHTML={{ __html: props.article.description }} />
    </article>
  );
}
export default ListItem;
